module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [(!_vm.isPlaybackTimePickerClosed) ? _c('div', {
    staticClass: "playback-time-picker-comp-container"
  }, [_c('playback-time-picker-comp', {
    on: {
      "onClose": function($event) {
        _vm.closePlaybackTimePicker()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.isCameraComponentClosed) ? _c('camera-comp', {
    attrs: {
      "cameraObj": _vm.channels[_vm.selectedCamera],
      "isActive": !_vm.isCameraComponentClosed
    },
    on: {
      "onClose": function($event) {
        _vm.closeCameraComponent()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clickable-layer-to-close-menu",
    class: {
      menuVisible: _vm.isMenuActive
    },
    on: {
      "click": function($event) {
        _vm.closeMenu()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-items"
  }, [_c('div', {
    staticClass: "menu-category"
  }, [_vm._v("Site")]), _vm._v(" "), _vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "menu-item",
      attrs: {
        "ontouchstart": ""
      },
      on: {
        "click": function($event) {
          _vm.selectSite(siteId)
        }
      }
    }, [_c('div', {
      staticClass: "menu-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "menu-info"
    }, [_c('div', {
      staticClass: "main-info"
    }, [_vm._v(_vm._s(site.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-info"
    }, [_vm._v(_vm._s(site.address))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-btn",
    class: {
      active: _vm.isMenuActive
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickMenu()
      }
    }
  }, [_c('div', {
    staticClass: "bar first"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar second"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar fourth"
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.currentSiteId) ? _c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.currentSite.localTimeNow().toLocaleTimeString()) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.bridges[_vm.selectedBridge].isOnline) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "offline-container"
  }, [_c('div', {
    staticClass: "status-text"
  }, [_vm._v("Can't connect to the bridge.")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    class: {
      'disable-click': _vm.bridges[_vm.selectedBridge].isCheckingConnection
    },
    on: {
      "click": function($event) {
        _vm.checkBridgeConnection(_vm.selectedBridge)
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].isCheckingConnection ? 'Checking status...' : 'Refresh status') + "\n          ")])])]) : (!_vm.bridges[_vm.selectedBridge].isAuthenticated) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "authentication-container"
  }, [_c('div', {
    staticClass: "status-text"
  }, [_vm._v("Authentication")]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bridges[_vm.selectedBridge].authUsername),
      expression: "bridges[selectedBridge].authUsername"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter username"
    },
    domProps: {
      "value": (_vm.bridges[_vm.selectedBridge].authUsername)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bridges[_vm.selectedBridge].authUsername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bridges[_vm.selectedBridge].authPassword),
      expression: "bridges[selectedBridge].authPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.bridges[_vm.selectedBridge].authPassword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bridges[_vm.selectedBridge].authPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    class: {
      'disable-click': _vm.bridges[_vm.selectedBridge].isAuthenticating
    },
    on: {
      "click": function($event) {
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].isAuthenticating ? 'Authenticating...' : 'Authenticate') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "error-text",
    class: {
      'visible': _vm.bridges[_vm.selectedBridge].authError
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].authError ? _vm.bridges[_vm.selectedBridge].authError : 'no message') + "\n          ")])])]) : _c('div', {
    staticClass: "wrapper"
  }, [(_vm.currentSiteId) ? _c('div', {
    staticClass: "cameras-container"
  }, _vm._l((_vm.currentSite.cameras), function(cameraId) {
    return _c('div', {
      key: cameraId,
      staticClass: "camera-container"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "camera-info"
    }, [_c('div', {
      staticClass: "camera-name prevent-text-overflow"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      }
    })]), _vm._v("\n                  " + _vm._s(_vm.camera(cameraId).name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("Last updated")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                    " + _vm._s(_vm.liveSnapshot(cameraId) ? _vm.currentSite.convertToLocalTime(_vm.liveSnapshot(cameraId).timestamp).toLocaleTimeString() : 'no info') + "\n                  ")])])]), _vm._v(" "), (!_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "svg-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0zm0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('img', {
      attrs: {
        "src": 'data:image/jpg;base64,' + _vm.liveSnapshot(cameraId).url
      }
    }) : _vm._e()])])
  })) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6905a1e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 276
// module chunks = 1